import { Text } from "@chakra-ui/react";

export default function Fear(){
    return(
        <>
        <Text className="text-format" style={{whiteSpace:"pre-line", alignContent:"center"}} >
        <br/>Does fear hold you back, while hope is hard to hold?
        <br/>
        <br/>Even for a moment?
        <br/>
        <br/>What helps you pass those fearful moments?
        <br/>Is there a version of you, who does not fear, has overcome
        <br/>and knows the way,
        <br/>to take a lead, and give you hope
        <br/>and a reminder, that there is a future
        <br/>and a hope through your fearful moments.
        <br/>Who has faced your fears?
        <br/>And who will you be when you have done?
        </Text>
        </>
    )
}